// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"f2037fed","228":"9a9beb38","358":"1ae3e66a","453":"841296c2","524":"3a69f0b1","655":"e7eddddb","696":"7e1354df","790":"04fb2e4b","871":"f5cc717b","929":"c1287e99","945":"d364f8c0"}[chunkId] + ".chunk.js";
};